export default __webpack_public_path__ + "static/media/Version (6) - Ultimate Map_32.a863a17b.jpg";